import React from 'react'
import axios from 'axios'
import apiUrl from '../../../../../apiConfig'
import Table from 'react-bootstrap/Table'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import DeleteSponsorModal from './DeleteSponsorModal'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'





class SponsorsTable extends React.Component {
  state = {
    deleteSponsorModal: false,
    selectedSponsorKey: '',
    selectedSponsorName: '',
    showImageModal: false,
    selectedImage: '',
    selectedType: ''
  }

  deleteSponsorModalClose = () => {
    this.setState({ deleteSponsorModal: false, selectedSponsorKey: '', selectedSponsorName: '' })
  }

  deleteSponsorModalOpen = (event) => {
    this.setState({
      deleteSponsorModal: true,
      selectedSponsorKey: event.currentTarget.dataset.id,
      selectedSponsorName: event.currentTarget.dataset.name,
    })
  }

  convertLink = (regLink) => {
    if (regLink.includes('=')) {
      const split = regLink.split('=')
      const embedLink = `https://www.youtube.com/embed/${split[1]}?autoplay=1`
      return embedLink
    } else if (regLink.includes('embed')) {
      return regLink + '?autoplay=1'
    } else {
      const split = regLink.split('/')
      const embedLink = `https://www.youtube.com/embed/${split[3]}?autoplay=1`
      return embedLink
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    console.log(event.target.name, 'name')
    console.log(event.target.dataset.id, 'data-id')
    console.log(this.state[`${event.target.dataset.id}-url`], 'value')
    console.log(event.target.dataset.name, 'data-name')
    console.log(this.props.userData[0].cognitoId, 'cognitoId')
    console.log(this.props.user, 'user props')

    axios({
      url: apiUrl + '/edit-sponsor-link',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.props.user.id} ${this.props.user.refresh} ${this.props.user.access}`
      },
      data: {
        cognitoId: this.props.userData[0].cognitoId,
        id: event.target.dataset.id,
        [event.target.name]: this.state[`${event.target.dataset.id}-url`],
        type: event.target.dataset.name
      }
    })
      .then(() => {
      this.setState({ [`${event.target.dataset.id}-${event.target.name}`]: '' })
      this.props.msgAlert({
        heading: 'Successfully Edited Sponsor Link',
        variant: 'success'
      })
      this.props.getSponsors()
    })
    .catch((err) => {
      this.props.msgAlert({
        heading: 'Error',
        message: err.response.data.error,
        variant: 'danger'
      })
    })
  }

  render () {
    return (
      <React.Fragment>
        <div style={{ marginTop: '4rem' }}>
          <Table striped bordered>
            <thead>
              <tr>
                <th>Name</th>
                <th>Image/Video</th>
                <th>URL</th>
                <th>Delete Sponser</th>
              </tr>
            </thead>
            <tbody>
              {this.props.theSponsors.map((sponsor) => (
                <tr key={sponsor.aws_key}>
                  <td>{sponsor.name}</td>
                  <td data-link={sponsor.image_link} data-video={sponsor.video} onClick={(event) => { this.setState({ showImageModal: true, selectedImage: event.target.dataset.link, selectedType: event.target.dataset.video })}} style={{ cursor: 'pointer' }}>{sponsor.video === 0 ? 'Click to See Image' : 'Click to See Video'}</td>

                  <td className='d-flex align-items-center justify-content-between'>
                    {sponsor.video === 1 ? sponsor.image_link : sponsor.website_link}
                    <div className='d-flex'>
                        Edit:&nbsp;
                        <Form className='d-flex' onSubmit={this.handleSubmit} name='url' data-id={sponsor.aws_key} data-name={sponsor.video === 1 ? 'video' : 'website'}>
                          <Form.Control
                            required
                            size='sm'
                            placeholder={sponsor.video === 1 ? 'enter new video url' : 'enter new website url'}
                            type='text'
                            name= {`${sponsor.aws_key}-url`}
                            defaultValue=''
                            value= {this.state[`${sponsor.aws_key}-url`]}
                            onChange={this.handleChange}
                          />&nbsp;
                          <Button type='submit' size='sm' variant='primary'>save</Button>
                        </Form>
                      </div>
                  </td>

                  <td><DeleteForeverIcon data-id={sponsor.aws_key} data-name={sponsor.name} onClick={(event) => this.deleteSponsorModalOpen(event)}></DeleteForeverIcon></td>
                </tr>
              ))}
            </tbody>
        </Table>
        <DeleteSponsorModal getSponsors={this.props.getSponsors} {...this.state} {...this.props} deleteSponsorModalClose={this.deleteSponsorModalClose}></DeleteSponsorModal>
      </div>
      {this.state.selectedImage &&
          <Modal show={this.state.showImageModal} onHide={() => this.setState({ showImageModal: false, selectedImage: '', selectedType: '' })}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <div className='d-flex justify-content-center'>
                {this.state.selectedType === '0' &&
                <div style={{ maxWidth: '350px' }} className='ratio ratio-4x3'>
                  <img src={this.state.selectedImage} alt='sponsor-img' />
                </div>
                }
                {this.state.selectedType === '1' &&
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" class="embed-responsive-item" src={this.convertLink(this.state.selectedImage)} allowfullscreen></iframe>
                </div>
                }
              </div>  
            </Modal.Body>
          </Modal>
      }
    </React.Fragment>
    )
  }
}

export default SponsorsTable